import { ProductReviewsResume } from "../../models/productReviewsResume";
import "./categoryProductListing.scss";

import CategoryProductListingSingle from "./CategoryProductListingSingle";
import React from "react";

type CategoryProductListingProps = {
    columns: string;
    products: any[];
    reviews: ProductReviewsResume[]
    isComparable: boolean;
    setCompareArray: (value: any[]) => void;
    compareArray: any[];
    scroll: any;
};

export default function CategoryProductListing(props: CategoryProductListingProps) {
    const { columns, products, isComparable, setCompareArray, compareArray, scroll, reviews } = props;
    return (
        <div className={`categoryProductListing col-${columns}`}>
            <div className="container">
                {products.map((product) => 
                    {                        
                    const review = reviews ? reviews.find((review) => review.sku === product.code) : undefined;
                    return <CategoryProductListingSingle
                        isComparable={isComparable}
                        setCompareArray={setCompareArray}
                        compareArray={compareArray}
                        product={product}
                        review={review}
                        key={product.code}
                        isDiscontinued={false}
                    />
                    }
                )}
                {scroll && (
                    <>
                        <div className="option-prev option-nav">
                            <span
                                className={
                                    scroll.relatedIndex !== 0
                                        ? "iconfont iconfont-prev"
                                        : "iconfont iconfont-prev not-clickable"
                                }
                                onClick={() =>
                                    scroll.relatedIndex !== 0 &&
                                    scroll.setRelatedIndex(scroll.relatedIndex - 1)
                                }
                            />
                        </div>
                        <div className="option-next option-nav">
                            <span
                                className={
                                    scroll.relatedIndex < scroll.length
                                        ? "iconfont iconfont-next"
                                        : "iconfont iconfont-next not-clickable"
                                }
                                onClick={() =>
                                    scroll.relatedIndex < scroll.length - scroll.listingWidth &&
                                    scroll.setRelatedIndex(scroll.relatedIndex + 1)
                                }
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
